/* ============================================================
   Мобильный нижний таб-бар (из макета «Мобильная версия»):
   Главная · Турниры · Новости · Эфир · Ещё.
   «Ещё» открывает полноэкранное меню.
   ============================================================ */
import { useAppStore } from '../../store';
import { useFedStore, useL } from '../store';
import { Ic } from '../icons';
import { messengerUnread, useMessenger } from '../messenger/store';

export default function FedBottomNav() {
  const route = useAppStore((s) => s.route);
  const { go, menuOpen, toggleMenu, closeMenu } = useFedStore();
  const L = useL();
  const conversations = useMessenger((s) => s.conversations);
  const unread = messengerUnread(conversations);

  const tabs = [
    { key: 'home', label: L.nav_home, icon: 'home', active: route === 'home' && !menuOpen },
    { key: 'tournaments', label: L.nav_tournaments, icon: 'trophy', active: ['tournaments', 'tournament'].includes(route) && !menuOpen },
    { key: 'messenger', label: useFedStore.getState().lang === 'kz' ? 'Чаттар' : 'Чаты', icon: 'chat', badge: unread, active: route === 'messenger' && !menuOpen },
    { key: 'live', label: L.nav_live, icon: 'play', active: route === 'live' && !menuOpen },
  ];

  return (
    <nav className="fed-tabbar">
      {tabs.map((t) => (
        <button
          key={t.key}
          className={`fed-tab fed-press ${t.active ? 'on' : ''}`}
          onClick={() => { closeMenu(); go(t.key); }}
        >
          <Ic name={t.icon} size={22} sw={1.8} />
          {t.badge > 0 && <i className="msg-tab-badge">{t.badge > 9 ? '9+' : t.badge}</i>}
          <span className="tl">{t.label}</span>
        </button>
      ))}
      <button
        className={`fed-tab fed-press ${menuOpen ? 'on' : ''}`}
        onClick={toggleMenu}
        aria-expanded={menuOpen}
        aria-controls="fed-mobile-menu"
      >
        <Ic name="more" size={22} sw={1.8} />
        <span className="tl">{useFedStore.getState().lang === 'kz' ? 'Тағы' : 'Ещё'}</span>
      </button>
    </nav>
  );
}
